"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuinationAbilityHandler = exports.RuinationActorAbilityFactory = exports.RuinationAbilityArgs = void 0;
const AbilityArgs_1 = require("../../core/abilities/AbilityArgs");
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
const core_2 = require("../../core/event-handlers/core");
const core_3 = require("../../core/actions/core");
class RuinationAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Ruination;
        this.__typeName = "Ruination";
    }
}
exports.RuinationAbilityArgs = RuinationAbilityArgs;
let RuinationActorAbilityFactory = class RuinationActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Ruination", "OneEnemies", 2);
    }
};
RuinationActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Ruination")
], RuinationActorAbilityFactory);
exports.RuinationActorAbilityFactory = RuinationActorAbilityFactory;
let RuinationAbilityHandler = class RuinationAbilityHandler {
    constructor() {
        this.summoningAbilities = new Set(Array.of("SummonSkeleton", "SummonLich", "SummonReaper", "SummonSpirit"));
    }
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        sequence = sequence.pushSequence("parallel");
        container.cancelEffect(sequence, container.readLocal(ability.invokerId, "Ruination_LastRuinationEffectId", -1));
        const [targetId] = ability.args.target.actorIds;
        const additionalEffects = Array.of();
        if (container.hasAttribute(ability.invokerId, "Charm_Necromancer_0")) {
            additionalEffects.push(new core_1.LinkedEventHandlerEffectArgs("Soul Fracture", "Chance to summon an enemy when damaged", true, container.registerEventHandler(targetId, EventType_1.EventType.Damaged, Schedule_1.Schedule.Unlimited, new core_2.DispatchRandomActionEventHandlerArgs(ability.invokerId, 30, [
                ...container.getEquippedAbilitySlots(ability.invokerId)
                    .map(slot => container.getAbilityInSlot(ability.invokerId, slot))
                    .filter(ability => this.summoningAbilities.has(ability.abilityType))
                    .map(ability => AbilityArgs_1.AbilityArgs.FromTypeName(ability.abilityType, Target_1.Target.Self))
                    .map(args => new core_3.UseAbilityActionArgs(args, false))
            ], true))));
        }
        const effectId = container.applyDebuff({
            sequence,
            attackerId: ability.invokerId,
            duration: Duration_1.Duration.Permanent,
            targetId,
            effect: new core_1.LinkedEffectsEffectArgs([
                new core_1.RuinationEffectArgs(),
                ...additionalEffects
            ], true)
        });
        container.setLocal(ability.invokerId, "Ruination_LastRuinationEffectId", effectId);
        container.setLocal(ability.invokerId, "Ruination_AppliedToId", targetId);
    }
};
RuinationAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Ruination)
], RuinationAbilityHandler);
exports.RuinationAbilityHandler = RuinationAbilityHandler;
